import React, {useRef} from 'react';
import {useTranslation} from 'react-i18next';
import {getToken, Helper} from '@tickchak/react-share/app';
import {useParagraphEditor} from '../../hooks/useParagraphEditor';
import {isContentEmpty} from '../../utils/domUtils';
import * as css from './ParagraphRow.css';
    
interface ParagraphRowProps {
    structureIndex: number;
    content: string;
    onChange?: (content: string) => void;
    onFocus?: () => void;
    setLastFocusedEditable?: (element: HTMLElement | null) => void;
    updateSavedCursorOffset?: () => void;
}

function ParagraphRow({structureIndex, content, onChange, onFocus, setLastFocusedEditable, updateSavedCursorOffset}: ParagraphRowProps) {
    const {t} = useTranslation('whatsapp');
    const contentEditableRef = useRef<HTMLDivElement>(null);

    const isEmpty = isContentEmpty(content);

    const {handleInput, handleKeyDown, handlePaste, handleBlur, handleFocus, handleCursorMove} = useParagraphEditor({
        content,
        contentEditableRef,
        onChange,
        onFocus,
        onEditableFocus: setLastFocusedEditable,
        onEditableCursorMove: updateSavedCursorOffset
    });

    return (
        <css.row isEmpty={isEmpty}>
            <css.contentEditable
                ref={contentEditableRef}
                contentEditable
                data-structure-index={structureIndex}
                data-is-empty={String(isEmpty)}
                onInput={handleInput}
                onKeyDown={handleKeyDown}
                onPaste={handlePaste}
                onFocus={handleFocus}
                onKeyUp={handleCursorMove}
                onMouseUp={handleCursorMove}
                onClick={handleCursorMove}
                onBlur={handleBlur}
                suppressContentEditableWarning
            />
            {isEmpty && (
                <Helper
                    content={t('emptyParagraphWarning')}
                    size='small'
                    maxWidth={240}
                    icon={'!'}
                    bgColor={getToken('color.state.warning.main')}
                />
            )}
        </css.row>
    );
}

export default ParagraphRow;
